import { FC } from 'react';

const IconCookie: FC<{ className?: string }> = ({ className }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                opacity="0.5"
                d="M21.66 9.41A10 10 0 1 1 15.42 2.6A5.5 5.5 0 0 0 21.66 9.41Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <circle cx="8.5" cy="9.5" r="1" fill="currentColor" />
            <circle cx="14.5" cy="15.5" r="1" fill="currentColor" />
            <circle cx="9" cy="15.5" r="1" fill="currentColor" />
            <circle cx="12.5" cy="11" r="0.75" fill="currentColor" />
        </svg>
    );
};

export default IconCookie;
